import React from 'react';
import shortid from 'shortid';
import PropTypes from 'prop-types';
import Item from './Item';

import {
  DetailStrong,
  DetailUpperBox,
  DividerStyled as Divider,
  TotalAmount,
  TotalBox,
} from './styles/AccordionStyled';
import DetailUpperBoxItem from './DetailUpperBoxItem';
import { Numbers } from '../../../../helpers';

const Accordion = ({
  data,
  children,
  dueDate,
  billingNumber,
  consumptionPeriod,
  total,
}) => {
  const items = data.map(item => {
    return (
      <React.Fragment key={shortid.generate()}>
        <Item data={item} />
        <Divider />
      </React.Fragment>
    );
  });

  const { from = '', to = '' } = consumptionPeriod;
  return (
    <>
      <DetailUpperBox>
        <DetailUpperBoxItem itemTitle="N° de factura">
          <strong>{billingNumber}</strong>
        </DetailUpperBoxItem>
        <hr />
        {from && to && (
          <>
            <DetailUpperBoxItem itemTitle="Período de consumo">
              <div>
                <strong>{consumptionPeriod.from}</strong> al
              </div>
              <strong>{consumptionPeriod.to}</strong>
            </DetailUpperBoxItem>
            <hr />
          </>
        )}

        {dueDate && (
          <DetailUpperBoxItem itemTitle="Vencimiento">
            <strong>{dueDate}</strong>
          </DetailUpperBoxItem>
        )}
      </DetailUpperBox>
      {data.length !== 0 && (
        <>
          <DetailStrong>Detalle de cobros:</DetailStrong>
        </>
      )}
      <Divider />
      {items}
      {children}
      {total !== '' && (
        <TotalBox>
          <TotalAmount>
            Total: ${Numbers.addThousandSeparators(total)}
          </TotalAmount>
        </TotalBox>
      )}
    </>
  );
};

Accordion.propTypes = {
  children: PropTypes.node,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number,
      name: PropTypes.string,
      subcategories: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          amount: PropTypes.number,
          line: PropTypes.string,
        })
      ),
    })
  ),
  dueDate: PropTypes.string.isRequired,
  billingNumber: PropTypes.string.isRequired,
  consumptionPeriod: PropTypes.shape({
    from: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
  }).isRequired,
  total: PropTypes.number.isRequired,
};

Accordion.defaultProps = {
  data: [
    {
      amount: 0,
      name: '',
      subcategories: [
        {
          name: '',
          amount: 0,
          line: '',
        },
      ],
    },
  ],
  children: <></>,
};

export default Accordion;
